module.exports = __webpack_public_path__ + "static/media/金融行业解决方案.3893d402.png";